import React, {ReactNode} from "react";

import ElitePassLogoFull from "../../assets/ElitePassLogoFull.png";

import styles from "./AuthCard.module.scss";

type AuthCardProps = {
  children: ReactNode;
  title: string;
  subtitle: string;
};

export default function AuthCard({children, title, subtitle}: AuthCardProps) {
  return (
    <div className={styles.card}>
      <div className={styles.headerContainer}>
        <img className={styles.logo} src={ElitePassLogoFull} />
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.subtitle}>{subtitle}</p>
      </div>
      {children}
    </div>
  );
}
